/* Name:Chaitali Khachane
   Description:This is the pop-up page,this page will render once we click on onboard button on data Assets screen
   in this page we will allow user to fill details to onboard asset like asst name ,description,country ,region etc....
   on Click on submit button it will call submit API and clear all the form values
   or cancel button will discard all the filled value without saving it
               
*/

import React, { Fragment, useEffect, useRef, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import FormDropdown from "../../component/dropdown/formDropdown"
import ErrorMessage from "../../component/errorMessage/errorMsg"
import FormInputDescription from "../../component/inputtext/formInputDescription"
import Forminputtext from "../../component/inputtext/forminputtext"
import PopUpScreen from "../../component/popUpScreen/popUpScreen"
import { emptyErrorCheck } from "../../helpers/validation/emptyValidation"
import { CLEAR_ALL_ERROR_MESSAGE, SET_ERROR_MESSAGE, SET_FORM_OPTION, SET_FORM_VALUE, SET_FORM_VALUEOBJ } from "../../redux/dataAsset/dataAsset.type"
import { emptycheckFields } from "../../validator/pageValidation"
import { FieldLabel } from "../global/global.style"
import { Button } from 'primereact/button';
import { Label, LabelWrapper } from "../../component/inputtext/inputtextStyle"
import { _alphaNumvalidateInput } from "../../helpers/validation/nameValidation"
import FileExplorerDirectory from "./fileExplorerDirectory"
import FileExplorerFile from "./fileExplorerFile"
import { addTags, getADLSFileList, reuploadFile } from "../../redux/dataAsset/dataAsset.action"
import { InputText } from "primereact/inputtext"
import { Tag } from "primereact/tag"
import FormTag from "../../component/tag/FormTag"


function AssetSummaryTagPopUp({ dataAssetId,tagArray, onHide, changeDetail }) {
    const { formData, apiData } = useSelector((state) => state.dataAsset)
    const dispatch = useDispatch()
    const [displayTags, setDisplayTags] = useState(tagArray)
    const [newTag, setNewTag] = useState("")
    const [tagError, setTagError] = useState("")
    const [fileExplorerFileEnable, setFileExplorerFileEnable] = useState(false)

    const closeDialog = () => {
        onHide()
    }
    const checkDuplicate = () => {
        let isDuplicate = false
        let newArray = newTag.split(",")
        displayTags.some((val1) => {
            newArray.some((val2) => {
                if (val2 === val1) {
                    isDuplicate = true
                }
            })

        })
        return isDuplicate
    }
    const removeTag = (tagName) => {
        const updatedTags = displayTags.filter(tag => tag !== tagName);
        setDisplayTags(updatedTags)
    }
    return <PopUpScreen style={{ width: "50%" }} header="Create a Tags" onHide={() => {
        closeDialog()
    }}
    >
        <div className="grid">
            <div className="col-10">
                <InputText style={{ width: "100%" }} placeholder="tag1, tag2, tag3 ..." value={newTag} onChange={(e) => {
                    setNewTag(e.target.value)
                }} />
                <ErrorMessage message={tagError} />
            </div>

            <div className="col-2">
                <Button
                    type="button"
                    label="Add"
                    onClick={() => {
                        setTagError("")
                        if (checkDuplicate()) {
                            setTagError("Duplicate Tag found.")
                        } else {
                            setNewTag("")
                            setDisplayTags([...displayTags, ...newTag.split(",")])
                        }

                    }
                    }
                    style={{ marginRight: "10px", height: "40px" }}
                    className="my-button"
                />
            </div>
        </div>
        <div style={{ paddingLeft: "5px" }}>
            <FieldLabel>
                Current Tags
            </FieldLabel>
            <div style={{ marginTop: "5px" }} className="grid">
                {displayTags.map((val) => {
                    return <div className="col-2">
                        <FormTag label={val} onRemove={removeTag} />
                    </div>
                })}
            </div>
        </div>
        <div className="grid" style={{ marginTop: "10px" }}>
            <div className="col-12" style={{ marginTop: "10px", textAlign: "right" }} >
                <Button style={{ width: "100px", textAlign: "center", marginRight: "10px" }} outlined label="Cancel" onClick={() => {
                   setNewTag("")
                   setTagError("")
                    onHide()
                }} />
                <Button style={{ width: "100px", textAlign: "center" }} label="Save"
                onClick={()=>{
                    dispatch(addTags(displayTags,dataAssetId))
                }}
                />
            </div>
        </div>

    </PopUpScreen>
}
export default AssetSummaryTagPopUp